import { css } from '@emotion/react';
import { colorPalette } from '../../colorPalette';
const linkSmall = css `
  display: inline-block;
  text-decoration: none;
  color: ${colorPalette.lightBlue800};
  font-size: 1.4rem;
  line-height: 16px;
  font-weight: 400;
  height: 18px;
`;
const linkLarge = css `
  display: inline-block;
  text-decoration: none;
  color: ${colorPalette.gray700};
  font-size: 2.4rem;
  line-height: 24px;
  font-weight: 400;
  height: 26px;
`;
export const link = (props) => css `
  ${props.size === 'large' ? linkLarge : linkSmall}

  &:hover > div > span {
    text-decoration-color: ${props.color ? props.color : colorPalette.gray1000};
  }
  &:focus > div > span {
    text-decoration-color: ${colorPalette.gray400};
  }
`;
export const cursor = css `
  cursor: pointer;
`;
export const linkContainer = (props) => css `
  display: flex;
  justify-items: center;
  align-items: center;
  align-content: center;
  gap: ${props.size === 'large' ? '12px' : '4px'};
  & > svg {
    font-size: 16px;
  }
`;
export const linkLabel = (props) => css `
  text-decoration: ${props.underline ? 'underline' : 'none'};
  text-underline-offset: 4px;
  text-decoration-color: rgba(0, 0, 0, 0.4);
  color: ${props.color ? props.color : 'inherit'};
  &:hover {
    text-decoration: underline;
  }
`;
